import {
  PostFAQInterface,
  UpdateFAQInterface,
  DeleteFAQInterface,
} from '@/data/payload/contracts/FAQRequest'

export class UpdateFAQRequest implements UpdateFAQInterface {
  private question: string
  private answer: string
  private isActive: boolean

  constructor(question: string, answer: string, isActive: boolean) {
    this.question = question
    this.answer = answer
    this.isActive = isActive
  }

  public toJSON() {
    const data = {
      question: this.question,
      answer: this.answer,
      is_active: this.isActive,
    }

    return JSON.stringify({
      data,
    })
  }
}
export class DeleteFAQRequest implements DeleteFAQInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class FAQApiRequest implements PostFAQInterface {
  private question: string
  private answer: string
  private isActive: boolean

  constructor(question: string, answer: string, isActive: boolean) {
    this.question = question
    this.answer = answer
    this.isActive = isActive
  }

  public toJSON() {
    const data = {
      question: this.question,
      answer: this.answer,
      is_active: this.isActive,
    }

    return JSON.stringify({
      data,
    })
  }
}
